var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.424805,
    y: 0.121582,
    width: 18.15,
    height: 18.15,
    rx: 9.075,
    fill: "#D5001C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4235_45818",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 9,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3564 7.76701C13.0213 9.4283 10.7245 13.0143 9.48906 14.7233C8.24231 12.9994 5.8402 9.11591 5.62699 7.76701C5.25592 5.41931 6.83355 3.44071 9.51071 3.44043C12.1879 3.44015 13.8084 5.52654 13.3564 7.76701Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.605
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4235_45818)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9452 1.93701H4.05518V15.852H14.9452V1.93701ZM9.50248 8.23067C10.215 8.23067 10.7927 7.65304 10.7927 6.94049C10.7927 6.22795 10.215 5.65032 9.50248 5.65032C8.78994 5.65032 8.21231 6.22795 8.21231 6.94049C8.21231 7.65304 8.78994 8.23067 9.50248 8.23067Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.89f9b0da615255c91c4ecc8f0ee2bbc9.svg";
export { ForwardRef as ReactComponent };